import Vue from 'vue'
import Vuex from 'vuex'
//定义为全局组件
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: window.localStorage.getItem('user') == null || window.localStorage.getItem('user') == "undefined" ? {} : JSON.parse(window.localStorage.getItem('user')),
    routes: [],
    userBalance: window.localStorage.getItem('balance') == null || window.localStorage.getItem('balance') == "undefined" ? '' : window.localStorage.getItem('balance'),
    voucherBalance: window.localStorage.getItem('voucherBalance') == null || window.localStorage.getItem('voucherBalance') == "undefined" ? '' : window.localStorage.getItem('voucherBalance')
  },
  mutations: {
    initMenu(state, menus){
      state.routes = menus;
    },
    login(state, user){
      state.user = user;
      window.localStorage.setItem('user', JSON.stringify(user));
    },
    logout(state){
      window.localStorage.removeItem('user');
      window.localStorage.removeItem('balance');
      window.localStorage.removeItem('hasTipBalance0');
      window.localStorage.removeItem('voucherBalance');
      state.user = null;
      state.routes = [];
    },
    setUserBalance(state, userBalance) {
      state.userBalance = userBalance;
    },
    setVoucherBalance(state, voucherBalance) {
      state.voucherBalance = voucherBalance;
    }
  },
  actions: {

  }
});
